import React, { forwardRef } from "react";
import moment from "moment";

const MFTransactionHistoryReportTable = forwardRef(
  (
    {
      tableData,
      handleTableScroll,
      // hasVerticalScroll,
      scrollLoaderTable,
      loader,
      LoaderForSearch,
      clientDashboard,
    },
    ref
  ) => {
    return (
      <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table last-column" style={{ width: "175%" }}>
        <thead>
          <tr>
            <th className={clientDashboard ? "text-center" : ""}>Sr No.
            </th>
            <th>Scheme Name
            </th>
            <th>Txn Type
            </th>
            <th>Folio Number
            </th>

            <th>Units
            </th>
            <th>NAV
            </th>
            <th>Amount
            </th>
            <th>Stamp Duty
            </th>
            <th>NAV Date
            </th>
            <th>Client Code
            </th>
            <th>Purchase Date
            </th>
          </tr>
        </thead>
        <tbody
          onScroll={(e) => handleTableScroll(e)}
          id="per-table-body"
          ref={ref}
        >
          {tableData?.length > 0 &&
            tableData.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={clientDashboard ? "text-center" : ""}>
                    {index + 1}
                  </td>
                  <td>{item?.schemeName}</td>
                  <td>{item?.txnType || "-"}</td>
                  <td>{item?.folioNo || "-"}</td>
                  <td>{item?.units || "-"}</td>
                  <td>{item?.nav || "-"}</td>
                  <td>{item?.amount || "-"}</td>
                  <td>{item?.stampDuty || "-"}</td>
                  <td>
                    {item?.navDate
                      ? moment(item?.navDate, "DD-MMM-YYYY").format(
                          "DD-MM-YYYY"
                        )
                      : "-"}
                  </td>
                  <td>{item?.clientCode || "-"}</td>
                  <td>{item?.purchDt || "-"}</td>
                </tr>
              );
            })}
          
        </tbody>
        {scrollLoaderTable && !loader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
      </table>
      </div>
    );
  }
);

export default MFTransactionHistoryReportTable;
